import { useMemo, useState } from 'react'

export function flattenFacts(facts, filter = 'all') {
  const flat = []
  for (const [section, arr] of Object.entries(facts || {})) {
    for (const f of arr) flat.push({ ...f, section })
  }
  flat.sort((a, b) => new Date(b.last_updated || 0) - new Date(a.last_updated || 0))
  if (filter === 'essentiels') return flat.filter(f => f.is_essentiel)
  return flat
}

export function useFactStream(facts) {
  const [filter, setFilter] = useState('all')
  const list = useMemo(() => flattenFacts(facts, filter), [facts, filter])
  return { list, filter, setFilter }
}
